var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 20.1l-4-4c1.1-1.5 1.8-3.3 1.8-5.3 0-4.7-3.8-8.5-8.5-8.5s-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5c2 0 3.8-.7 5.3-1.8l4 4c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1.1 0-1.4zM4.2 10.7c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.8-.7 3.4-1.9 4.6s-2.8 1.9-4.6 1.9c-3.5.1-6.5-2.9-6.5-6.5z",
    fill: "#101010"
  })));
}

export default SvgIconSearch;